<template>
    <div class="meituan-order-list">
        <el-card class="page-card">
            <template #header>
                <div class="card-header">美团订单列表</div>
            </template>

            <div class="card-body">
                <el-row type="flex" justify="space-between" align="middle" class="toolbar">
                    <el-col>
                        <el-button type="primary" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
                    </el-col>
                    <el-col>
                        <el-input size="small" placeholder="按订单号搜索" v-model="filters.order_no" style="width:200px"
                            clearable @clear="fetchData" @keyup.enter.native="fetchData">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                        <el-input size="small" placeholder="按公司ID搜索" v-model="filters.company_id"
                            style="width:200px; margin-left:8px" clearable @clear="fetchData"
                            @keyup.enter.native="fetchData">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                    </el-col>
                </el-row>

                <el-table :data="pageData" stripe border style="width: 100%; margin-top: 12px" row-key="id"
                    :loading="loading">
                    <el-table-column prop="id" label="ID" width="100" align="center" header-align="center" />
                    <el-table-column prop="order_number" label="订单号" width="" align="center" header-align="center" />
                    <el-table-column prop="amount" label="订单金额" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <span class="amount">¥ {{ row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="company_id" label="公司ID" width="" align="center" header-align="center" />
                    <el-table-column prop="order_status" label="订单状态" width="" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="getStatusTagType(row.order_status)">{{
                                formatStatus(row.order_status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="下单时间" width="" align="center" header-align="center" />
                    <el-table-column prop="pay_time" label="支付时间" width="" align="center" header-align="center" />
                    <!-- <el-table-column label="操作" fixed="right" width="150" align="center" header-align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleDetails(scope.row)">详情</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

                <div class="pagination-wrap">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="pager.pageSize" :current-page.sync="pager.page"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-card>

        <!-- 订单详情对话框 -->
        <el-dialog :visible.sync="detailDialog" title="订单详情" width="600px" :close-on-click-modal="false">
            <div v-if="detailData">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="ID">{{ detailData.id }}</el-descriptions-item>
                    <el-descriptions-item label="订单号">{{ detailData.order_no }}</el-descriptions-item>
                    <el-descriptions-item label="订单金额">¥ {{ detailData.amount }}</el-descriptions-item>
                    <el-descriptions-item label="公司ID">{{ detailData.company_id }}</el-descriptions-item>
                    <el-descriptions-item label="订单状态">{{ formatStatus(detailData.order_status)
                        }}</el-descriptions-item>
                    <el-descriptions-item label="下单时间">{{ detailData.create_time }}</el-descriptions-item>
                    <el-descriptions-item label="支付时间">{{ detailData.pay_time || '-' }}</el-descriptions-item>
                    <!-- 根据实际数据结构调整其他字段 -->
                    <el-descriptions-item label="商品名称">{{ detailData.product_name || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="商家名称">{{ detailData.shop_name || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="备注">{{ detailData.remark || '-' }}</el-descriptions-item>
                </el-descriptions>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { meituanOrderList } from '@/api/api'

export default {
    name: 'MeituanOrderList',
    data() {
        return {
            loading: false,
            list: [],
            total: 0,
            pager: { page: 1, pageSize: 15 },
            filters: { order_no: '', company_id: '' },
            detailDialog: false,
            detailData: null
        }
    },
    computed: {
        pageData() {
            // 服务端已处理分页，直接返回list
            return this.list
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.pager.page,
                    per_page: this.pager.pageSize,
                    order_no: this.filters.order_no || undefined,
                    company_id: this.filters.company_id || undefined
                }
                const res = await meituanOrderList(params)

                this.list = res.data.data || []
                this.total = res.data.total
            } catch (err) {
                console.error('meituanOrderList error', err)
                this.$message.error(err.message || '获取美团订单列表失败')
                // 提供模拟数据以便展示
                this.list = this.getMockData()
                this.total = this.list.length
            } finally {
                this.loading = false
            }
        },

        // 获取模拟数据
        getMockData() {
            return [
                {
                    id: 1,
                    order_no: 'MT20241110001',
                    product_name: '双人套餐',
                    shop_name: '海底捞火锅(北京王府井店)',
                    order_type: 1,
                    amount: 298,
                    company_id: 101,
                    order_status: 1,
                    delivery_address: '北京市东城区王府井大街1号',
                    contact_name: '张三',
                    contact_phone: '138****1234',
                    create_time: '2024-11-10 12:00:00',
                    pay_time: '2024-11-10 12:01:00',
                    remark: '加辣'
                },
                {
                    id: 2,
                    order_no: 'MT20241110002',
                    product_name: '商务午餐',
                    shop_name: '西贝莜面村(中关村店)',
                    order_type: 2,
                    amount: 88,
                    company_id: 102,
                    order_status: 2,
                    delivery_address: '北京市海淀区中关村大街1号',
                    contact_name: '李四',
                    contact_phone: '139****5678',
                    create_time: '2024-11-10 11:30:00',
                    pay_time: '2024-11-10 11:31:00'
                },
                {
                    id: 3,
                    order_no: 'MT20241110003',
                    product_name: '下午茶套餐',
                    shop_name: '星巴克(国贸店)',
                    order_type: 3,
                    amount: 58,
                    company_id: 103,
                    order_status: 4,
                    delivery_address: '北京市朝阳区建国门外大街1号',
                    contact_name: '王五',
                    contact_phone: '137****9012',
                    create_time: '2024-11-10 15:00:00',
                    pay_time: '2024-11-10 15:01:00'
                },
                {
                    id: 4,
                    order_no: 'MT20241110004',
                    product_name: '单人套餐',
                    shop_name: '肯德基(三里屯店)',
                    order_type: 1,
                    amount: 39.9,
                    company_id: 101,
                    order_status: 8,
                    delivery_address: '北京市朝阳区三里屯路19号',
                    contact_name: '赵六',
                    contact_phone: '136****3456',
                    create_time: '2024-11-10 12:30:00',
                    pay_time: '2024-11-10 12:31:00'
                },
                {
                    id: 5,
                    order_no: 'MT20241110005',
                    product_name: '家庭套餐',
                    shop_name: '必胜客(朝阳公园店)',
                    order_type: 2,
                    amount: 158,
                    company_id: 102,
                    order_status: 9,
                    delivery_address: '北京市朝阳区朝阳公园路1号',
                    contact_name: '孙七',
                    contact_phone: '135****7890',
                    create_time: '2024-11-10 18:00:00',
                    pay_time: '2024-11-10 18:01:00'
                }
            ]
        },

        formatStatus(order_status) {
            const statusMap = {
                1: '提交订单',
                2: '向餐厅推单',
                4: '已接单',
                8: '已完成',
                9: '取消'
            }
            return statusMap[order_status] || '未知'
        },

        getStatusTagType(order_status) {
            const typeMap = {
                1: 'primary',
                2: 'info',
                4: 'success',
                8: 'success',
                9: 'danger'
            }
            return typeMap[order_status] || 'default'
        },

        handleDetails(row) {
            this.detailData = row
            this.detailDialog = true
        },

        handleSizeChange(size) {
            this.pager.pageSize = size
            this.pager.page = 1
            this.fetchData()
        },

        handleCurrentChange(page) {
            this.pager.page = page
            this.fetchData()
        }
    }
}
</script>

<style scoped>
.page-card {
    margin: 20px 12px;
    height: calc(100vh - 64px - 48px);
    overflow-y: auto;
}

.card-header {
    font-weight: 700;
    color: #409EFF;
}

.card-body {
    padding: 12px;
}

.toolbar {
    margin-bottom: 6px;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.amount {
    color: #F56C6C;
    font-weight: 700;
}
</style>